
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_3913_2919)"}},[_c('path',{attrs:{"opacity":".3","d":"M5.05 9.9l2.475-2.276L9.9 5.445H.1l2.475 2.179L5.05 9.9zm0-9.9l2.475 2.277L9.9 4.455H.1l2.475-2.178L5.05 0z","fill":"#000"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_3913_2919"}},[_c('path',{attrs:{"fill":"#fff","transform":"matrix(1 0 0 -1 0 10)","d":"M0 0h10v10H0z"}})])])])
          )
        }
      }
    